module.exports = __webpack_public_path__ + "img/icon-attch_off.09fe3ebb.svg";